import { Stack, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BrandLogoIcon } from "../../assets/customIcons";
import { BajajBorderLogo } from "../../assets/images";
import { EUserRole, LOCAL_STORAGE_KEYS, Module, headerTitle, isModuleConfig } from "../../constants";
import { getLocalStorageItem } from "../../utils/storageHelper";
import { MuiBox } from "../atoms/boxComponent";
import { MuiStack } from "./stackComponent";
import { systemColor } from "../../theme/systemColor";
export var LogoComponent = function (props) {
    var selectedDesignationStorage = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var _a = useState(""), pageTitle = _a[0], setPageTitle = _a[1];
    var location = useLocation();
    var navigate = useNavigate();
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var inspection = useParams().inspection;
    var selectedMenuGroup = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_MENU);
    function getPageTitle() {
        var path = window.location.pathname.substring(1).toLowerCase();
        var selectedMenuItem = '';
        var title = headerTitle.some(function (menu) {
            var lowercasePaths = menu.paths.map(function (p) { return p.toLowerCase(); });
            if (lowercasePaths.some(function (p) { return path.startsWith(p); })) {
                selectedMenuItem = menu.section;
                return true;
            }
            return false;
        });
        if (Module == isModuleConfig.Bajaj && inspection) {
            setPageTitle(t("HEADER_TITLE_VI"));
            return t('HEADER_TITLE_VI');
        }
        else {
            setPageTitle(title ? selectedMenuItem : '');
            return title ? selectedMenuItem : '';
        }
    }
    useEffect(function () {
        getPageTitle();
    }, [location]);
    var handleClick = function () {
        navigate("/dashboard");
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        paddingX: 1.5,
        spacing: lgMode ? 2 : 1
    }, /*#__PURE__*/ React.createElement(MuiBox, {
        sx: {
            alignItems: 'center',
            display: 'flex'
        }
    }, Module === isModuleConfig.Bajaj && lgMode ? /*#__PURE__*/ React.createElement("img", {
        alt: "logo",
        src: BajajBorderLogo,
        height: 35,
        width: 66,
        onClick: handleClick
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, lgMode ? /*#__PURE__*/ React.createElement(BrandLogoIcon, {
        fontSize: "large",
        style: {
            width: '216px',
            height: '36px',
            display: 'flex',
            color: 'white'
        }
    }) : null)), lgMode && /*#__PURE__*/ React.createElement(MuiStack, {
        borderRight: '1px white solid'
    }), /*#__PURE__*/ React.createElement(Stack, {
        justifyContent: "center"
    }, pageTitle !== "Dashboard" && /*#__PURE__*/ React.createElement(Typography, {
        noWrap: true,
        color: systemColor === null || systemColor === void 0 ? void 0 : systemColor.tertiaryTextColor,
        variant: "subtitle2",
        maxWidth: 110
    }, selectedMenuGroup ? selectedMenuGroup === null || selectedMenuGroup === void 0 ? void 0 : selectedMenuGroup.DisplayName : ""), /*#__PURE__*/ React.createElement(Typography, {
        id: "pageName",
        noWrap: true,
        fontWeight: 'strong',
        fontSize: 'lg',
        color: "#FFFFFF",
        maxWidth: 170
    }, t(pageTitle)), (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) === EUserRole.FinalInspector && pageTitle == "Dashboard" && /*#__PURE__*/ React.createElement(Typography, {
        id: "FI-Name",
        noWrap: true,
        textAlign: "left",
        variant: "h3",
        color: "#F4F7FA",
        maxWidth: 170
    }, t("Final Inspector"))));
};
